<template>
  <div>
    <div class="control-zoom">
      <b-button variant="light"
        class="btn-round zoom-btn"
        @click.prevent="zoomout"
      >
        <font-awesome-icon :icon="['fas', 'minus']" size="sm"/>
      </b-button>
        <span class="percent">{{ percent }} %</span>

      <b-button variant="light"
        class="btn-round zoom-btn"
        @click.prevent="zoomin"
      >
        <font-awesome-icon :icon="['fas', 'plus']" size="sm"/>
      </b-button>
    </div>
    <b-form-input
      v-model="uscale"
      type="range"
      min="0" max="2"
      step="0.01"
      @update="handleChange"
    >
    </b-form-input>
  </div>
</template>

<script>

export default {
  props: {
    scale: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      uscale: 1
    }
  },
  mounted () {
    this.uscale = this.scale
  },
  computed: {
    percent () {
      return Math.floor(Number(this.uscale) * 100)
    }
  },
  methods: {
    round (number, ndecimals) {
      return Number(Math.round(number + 'e' + ndecimals) + 'e-' + ndecimals)
    },
    zoomout () {
      this.uscale = Number(this.uscale) - this.round((1 / 100), 2)
      this.handleChange()
    },
    zoomin () {
      this.uscale = Number(this.uscale) + this.round((1 / 100), 2)
      this.handleChange()
    },
    handleChange () {
      console.log(this.uscale);
      
      this.$emit('zoom', this.round(Number(this.uscale), 2))
    }
  }
}
</script>

<style lang="scss" scoped>
.zoom-btn { 
  display: flex;
  align-items: center;
}
.zoom {
  position: absolute;
  bottom: 30px;
  right: 30px;
  .percent {
    font-family: "Open Sans";
    font-size: 13px;
    font-weight: bold;
  }
  .btn-circle {
    width: 45px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    padding: 0;
    border-radius: 50%;
  }
  .btn-circle-sm {
    width: 35px;
    height: 35px;
    line-height: 35px;
    font-size: 0.9rem;
  }
}
.zoom-menu, .opacity-menu {
  .control-zoom {
    display: flex;
    align-items: center;
    span  {
      padding-left: 15px;
      padding-right: 15px;
      font-size: 12px;
      color: #2b3085;
      line-height: 12px;
    }
  }

  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 1px solid #2b3085;
    height: 8px;
    width: 8px;
    border-radius: 50%x;
    background: #2b3085;
    cursor: pointer;
    margin-top: 0;
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/zoom.vue